export const numFontSizeToString = {
    1: 'var(--xxxlarge-text-size)',
    2: 'var(--xxlarge-text-size)',
    3: 'var(--xlarge-text-size)',
    4: 'var(--large-text-size)',
    5: 'var(--med-text-size)',
    6: 'var(--smedium-text-size)',
    7: 'var(--text-size)',
    8: 'var(--small-text-size)',
    9: 'var(--xsmall-text-size)',
    10: 'var(--xxsmall-text-size)',
    11: 'var(--xxxsmall-text-size)',
};

export const UserSettingsFontSizeToCSSFontSize = {
    xsmall: 'var(--xxsmall-text-size)',
    small: 'var(--xsmall-text-size)',
    medium: 'var(--small-text-size)',
    large: 'var(--text-size)',
};

export type NumFontSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
